import React from 'react';
import { Link } from 'react-router';
import ErrorBanner from './ErrorBanner';
import type { ParsedLscMutationError } from '../entitlementBillingErrors';
import { lscPath } from '../routing';

interface LscMutationErrorAlertProps {
  error: ParsedLscMutationError | null;
  onDismiss?: () => void;
}

const LscMutationErrorAlert: React.FC<LscMutationErrorAlertProps> = ({ error, onDismiss }) => {
  if (!error) return null;

  return (
    <div className="space-y-2" data-testid="lsc-mutation-error-alert">
      <ErrorBanner message={error.message} onDismiss={onDismiss} />
      {(error.showBillingLink || error.showPricingLink) && (
        <div className="flex flex-wrap gap-3 text-sm">
          {error.showBillingLink && (
            <Link
              to={lscPath('/billing')}
              className="text-primary-300 hover:text-primary-200"
              data-testid="lsc-mutation-error-billing-link"
            >
              View billing
            </Link>
          )}
          {error.showPricingLink && (
            <Link
              to={lscPath('/pricing')}
              className="text-primary-300 hover:text-primary-200"
              data-testid="lsc-mutation-error-pricing-link"
            >
              View pricing
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

export default LscMutationErrorAlert;
